<template>
  <article class="d-flex position-relative mb-3">
    <a :href="`${link}`" class="Card-link Card-link--secondary stretched-link"></a>
    <div class="Post-image" :style="`background-image: url('${post.imagePath}')`">
      <div v-if="post.eventTC" class="position-absolute top-0 left-0">
        <div class="ActionFeature">
          <img alt="logo" class="img-fluid" src="@/components/navigation/orp-logo.svg">
        </div>
      </div>
    </div>
    <div class="p-3 p-md-3 w-100 min-w-0">
      <div class="row mb-2">
        <div class="col-md-9">
          <h3 class="h5 Post-header mb-2 mb-lg-0">{{ post.title }}</h3>
        </div>
        <div class="col-md-3 text-md-right">
          <p v-if="isActionContinues(post.dateFrom, post.dateTo) && isDateShow" class="h5 font-size-sm">
            {{ i18nValue.today }}
          </p>
        </div>
      </div>
      <p v-if="post.dateFrom && post.dateTo" class="font-size-sm">
        <span class="font-weight-semi-bold">{{i18nValue.when }}:&nbsp;</span>
        {{ intervalFormatted(post.dateFrom, post.dateTo) }}
      </p>
      <p class="font-size-sm"><span class="font-weight-semi-bold">{{ i18nValue.where }}:&nbsp;</span>{{ post.venue }}</p>
    </div>
    <div class="d-none d-xl-flex flex-column justify-content-center flex-shrink-0">
      <div class="Post-arrow">
        <svg class="icon-small ml-2">
          <use xlink:href="#icon-chevron-right"></use>
        </svg>
      </div>
    </div>
  </article>
</template>

<script>

const locale = document.documentElement.lang;

export default {
  props: {
    post: {
      type: Object
    },
    link: {
      type: String
    },
    isDateShow: {
      type: Boolean,
      default: true
    },
    i18n: {
      type: Object,
    }
  },
  data() {
    return {
     i18nValue: {...this.i18n}
    };
  },
  methods: {
    dateFormatted(date) {
      return this.$date(date).format('l') + ', ' + this.$date(date).format('LT')
    },
    timeIsZero(date) {
      return this.$date(date).hour() === 0 && this.$date(date).minute() === 0 && this.$date(date).second() === 0
    },
    intervalFormatted(dateFrom, dateTo) {
      const dateFromFormatted = this.$date(dateFrom).format('l')
      const timeFromFormatted = !this.timeIsZero(dateFrom) ? ` ${this.$date(dateFrom).format('LT')}` : ''
      const dateToFormatted = this.$date(dateTo).format('l')
      const timeToFormatted = !this.timeIsZero(dateTo) ? ` ${this.$date(dateTo).format('LT')}` : ''

      /*
      if (this.timeIsZero(dateFrom) && this.timeIsZero(dateTo)) {
        return dateFromFormatted
      }*/

      if (this.$date(dateFrom).diff( this.$date(dateTo), 'day') !== 0) {
        return dateFromFormatted + timeFromFormatted + ' - ' + dateToFormatted + timeToFormatted
      } else {
        if ( timeToFormatted )
        {
          return  dateFromFormatted + timeFromFormatted + ' - ' + timeToFormatted
        }
        else
        {
          return  dateFromFormatted + timeFromFormatted
        }
      }
    },
    isActionContinues(dateFrom, dateTo) {
      const today = new Date();
      return today >= this.$date(dateFrom) && today <= this.$date(dateTo)
    },

  }
};
</script>
